module.exports = __webpack_public_path__ + "static/media/kallberga_osmo.95e946fa.png";